<template lang="pug">
BlueSearch.video-library
  template(#header="{}")
    SearchQuery
      template(#default="{results, query, setQuery, sort, setSort, executeSearch, currentResultsStart, currentResultsEnd, extended}")
        VideoLibraryQuery(:results="results", :query="query", :setQuery="setQuery", :sort="sort", :setSort="setSort", :executeSearch="executeSearch", :currentResultsStart="currentResultsStart", :currentResultsEnd="currentResultsEnd", :extended="extended", :hasFilters="hasFilters" :searchSubmitted="searchSubmitted", @setSearchSubmitted="searchSubmitted = $event" @setHasFilters="hasFilters = $event" @setActiveFilters="activeFilters = $event")
  template(#results="{}")
    template
      SearchResults
        template(#default="{results, reloading}")
          VideoLibraryResults(:results="results", :reloading="reloading", :searchSubmitted="searchSubmitted" :hasFilters="hasFilters" :activeFilters="activeFilters")
</template>

<script>
// import Item from "./components/results/Item.vue";
import VideoLibraryResults from "./components/results/VideoLibraryResults.vue";
import VideoLibraryQuery from "./components/query/VideoLibraryQuery.vue";
export default {
  name: "OICVideoLibrary",
  components: {
    VideoLibraryResults,
    VideoLibraryQuery
	},
  data () {
    return {
      searchSubmitted: false,
      hasFilters: false,
      activeFilters: null
    }
  },
  mounted () {
    const data = this.$store.getters;
    const hasQuery = data.query.length > 0;
    if (hasQuery) {
      this.searchSubmitted = true;
    }
  }
};
</script>

<style lang="scss">
#bluesearch {
  .search__footer {
    display: none;
  }
}
// All possible CSS variable overrides
// #bluesearch {
//   --font-size: 1rem/* property value */;
//   --font-weight: 300/* property value */;
//   --font-family: #{$fontFamilyBase}/* property value */;
//   --line-height: .8rem/* property value */;
//   --color: $occGray/* property value */;

//   --link-color: inherit/* property value */;
//   --link-hover-color: inherit/* property value */;
//   --link-transition: all .25s ease-in-out/* property value */;

//   --loader-color: #{$occBlue}/* property value */;

//   --accordion-title-color: /* property value */;
//   --accordion-title-active-color: /* property value */;
//   --accordion-title-transition: all .25s ease-in-out/* property value */;

//   --border-color: #{$occGray}/* property value */;

//   --label-color: #{$occGray}/* property value */;
//   --label-background: /* property value */;

//   --button-color: #{$buttonPrimaryColor} /* property value */;
//   --button-background: #{$occBlue}/* property value */;
//   --button-hover-color: #{$buttonPrimaryColorHover}/* property value */;
//   --button-hover-background: #2e4d81 /* property value */;
//   --button-transition: all .25s ease-in-out/* property value */;

//   --check-background: /* property value */;
//   --check-border: /* property value */;
//   --check-active-color: /* property value */;
//   --check-active-background: /* property value */;
//   --check-active-border: /* property value */;
//   --check-transition: all .25s ease-in-out/* property value */;

//   --tag-color: /* property value */;
//   --tag-background: /* property value */;
//   --tag-hover-color: /* property value */;
//   --tag-hover-background: /* property value */;
//   --tag-transition: all .25s ease-in-out/* property value */;

//   --pagination-nav-color: /* property value */;
//   --pagination-nav-background: /* property value */;
//   --pagination-nav-hover-color: /* property value */;
//   --pagination-nav-hover-background: /* property value */;
//   --pagination-nav-disabled-opacity: /* property value */;
//   --pagination-nav-transition: all .25s ease-in-out/* property value */;

//   --pagination-number-color: #{$occLightGray}/* property value */;
//   --pagination-number-background: /* property value */;
//   --pagination-number-hover-color: #{$occBlue} /* property value */;
//   --pagination-number-hover-background: /* property value */;
//   --pagination-number-active-color: #{$occGray}/* property value */;
//   --pagination-number-active-background: /* property value */;
//   --pagination-number-transition: all .25s ease-in-out/* property value */;
// }
//   .search {
//     &__main {

//     }
//     &__results {

//     }
//     &__footer {

//     }
//   }
//   .search-query {
//     &__form {
//       justify-content: space-between;
//       @include mq(lg){
//         max-height: 40px;
//       }
//     }
//     &__wrapper {
//       border-radius: 4px;
//       flex: 0 1 90%;
//     }
//     &__input {
//       font-weight: 400;
//       padding: .35rem .75rem;
      
//       &::placeholder{
//         font-weight: 400;
//       }
//     }
//     &__submit { 
//       border-radius: 4px;
//       flex: 0 1 78px;
//       font-family: #{$fontFamilyHeadings};
//     }
//     &__sort {
//       // display: none;
//     }
//     &__results {
//       font-size: 1rem;
//       margin-top: .25rem;
//       padding: 0;
//     }
//   }
//   .search-result {
//     border-bottom-color: #d8d8d8;
//     @include mq(lg) {
//       padding-bottom: 0;
//     }
//     &__img{
//       display: none; // temp
//     }
//     &__content {

//     }
//     &__title {
//       font-size: 1rem;
//       font-weight: 500;
//       line-height: 1.3;
//     }
//     &__date {
//       display: none; // temp
//     }
//     &__summary {
//       font-size: 1rem;
//       margin-top: 0;
//       padding-bottom: .1rem;
//     }
//   }
//   .search-pagination {
//     margin: 0 auto 2rem;
//     &__inner {
//       align-items: center;
//       justify-content: space-evenly;
//       gap: 0;
//     }
//     &__prev,
//     &__next {
//       &:before {
//         color: #{$occBlue};
//         font-family: "Font Awesome 5 Pro";
//         font-weight: 400;
//       }
//       &:after {
//         content:'';
//         border: none;
//         height: auto;
//         width: auto;
//       }
//     }
//     &__prev {
//       &:before {
//         content: "\f060";
//       }
//     }
//     &__number {
//       font-family: #{$fontFamilyHeadings};
//       font-size: 1.125rem;
//       font-weight: 600;
//     }
//     &__next {
//       &:before {
//         content: "\f061"
//       }
//     }
//   }
// }
</style>